import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "items" }
const _hoisted_2 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_el_input = _resolveComponent("el-input")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Highlight = _resolveComponent("Highlight")
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_input, {
      modelValue: $data.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.search) = $event)),
      modelModifiers: { trim: true },
      size: "large",
      placeholder: "Search",
      class: "search-input"
    }, {
      prefix: _withCtx(() => [
        _createVNode(_component_Icon, {
          icon: "search",
          stroke: "var(--gray-500)",
          width: "2rem",
          height: "2rem"
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_Divider, { m: "0 -1.6rem 0" }),
    _createElementVNode("div", _hoisted_1, [
      ($options.c_items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Nothing found "))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.c_items, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item,
              class: "item"
            }, [
              _createVNode(_component_Checkbox, {
                "model-value": $data.chosens.has(item),
                "checked-value": item,
                onChange: $event => ($options.onChecked(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Highlight, {
                    text: item,
                    highlight: $data.search
                  }, null, 8 /* PROPS */, ["text", "highlight"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "checked-value", "onChange"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}